<template>
  <el-dialog title="添加鲜花商家" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--form表单-->
    {{ shop_user_id }}11
    <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">
      <el-form-item label="用户名" prop="user_name">
        <el-input v-model="form.user_name" placeholder="请输入用户名">
        </el-input>
      </el-form-item>
      <el-form-item label="所属角色">
        <el-tag type="success" size="medium">{{ flowerRoleName }}</el-tag>
        <div class="role-tip">自动分配鲜花商家角色</div>
      </el-form-item>
      <el-form-item label="登录密码" prop="password"><el-input v-model="form.password" placeholder="请输入登录密码" type="password"></el-input></el-form-item>
      <el-form-item label="确认密码" prop="confirm_password"><el-input v-model="form.confirm_password" placeholder="请输入确认密码" type="password"></el-input></el-form-item>
      <el-form-item label="姓名" prop="real_name"><el-input v-model="form.real_name" placeholder="请输入姓名"></el-input></el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading" :disabled="!flowerRoleId">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AuthApi from '@/api/auth.js';
export default {
  data() {
    return {
      formLabelWidth: '120px',
      loading: false,
      dialogVisible: false,
      form: {
        user_name: '',
        password: '',
        confirm_password: '',
        real_name: ''
      },
      formRules: {
        user_name: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入登录密码',
            trigger: 'blur'
          }
        ],
        confirm_password: [
          {
            required: true,
            message: '请输入确认密码',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        real_name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }
        ]
      },
      // 动态获取鲜花商家角色
      flowerRoleId: null,
      flowerRoleName: '鲜花商家'
    };
  },
  props: ['open', 'roleList','shop_user_id'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
        if (this.open) {
          this.$nextTick(() => {
            this.form = {
              user_name: '',
              password: '',
              confirm_password: '',
              real_name: ''
            };
            if (this.$refs.form) {
              this.$refs.form.clearValidate();
            }
            // 打开弹窗时查找鲜花商家角色
            this.findFlowerRole();
          });
        }
      }
    },
    roleList: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.findFlowerRole();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 查找鲜花商家角色
    findFlowerRole() {
      if (!this.roleList || this.roleList.length === 0) return;
      
      // 查找包含"鲜花"的角色
      const flowerRole = this.roleList.find(role => 
        role.role_name.includes('鲜花') || 
        (role.role_name_h1 && role.role_name_h1.includes('鲜花'))
      );
      
      if (flowerRole) {
        this.flowerRoleId = flowerRole.role_id;
        this.flowerRoleName = flowerRole.role_name_h1 || flowerRole.role_name;
      } else {
        // 如果没有找到鲜花商家角色，使用第一个角色作为备选
        console.warn('未找到鲜花商家角色，使用第一个角色作为备选');
        const firstRole = this.roleList[0];
        this.flowerRoleId = firstRole.role_id;
        this.flowerRoleName = firstRole.role_name_h1 || firstRole.role_name;
      }
      
      console.log('鲜花商家角色ID:', this.flowerRoleId);
      console.log('鲜花商家角色名称:', this.flowerRoleName);
    },
    
    onSubmit() {
      let self = this;
      
      // 检查是否已获取到角色ID
      if (!self.flowerRoleId) {
        self.$message.error('未找到鲜花商家角色，请稍后重试');
        return;
      }
      
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        
        self.loading = true;
        
        // 动态使用鲜花商家角色ID
        let params = {
          user_name: self.form.user_name,
          password: self.form.password,
          confirm_password: self.form.confirm_password,
          real_name: self.form.real_name,
          role_id: [self.flowerRoleId], // 动态获取的鲜花商家角色
          school_user_id: self.shop_user_id || 0
        };
        
        console.log('提交参数:', params);
        
        AuthApi.userAdd(params, true)
          .then(data => {
            self.loading = false;
            if (data.code === 1) {
              self.$message({
                message: '恭喜你，鲜花商家添加成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            } else {
              self.$message.error(data.msg || '添加失败');
            }
          })
          .catch(error => {
            self.loading = false;
            self.$message.error('网络错误，请重试');
          });
      });
    },

    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style scoped>
.role-tip {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/auth/user/dialog/AddSupply.vue